import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, memo } from 'react';
// Option for big lists
var SimplifiedOptionInner = function (props) {
    var styles = props.getStyles('option', props);
    var data = props.data, selectOption = props.selectOption, innerProps = props.innerProps;
    var handleClick = useCallback(function () { return selectOption(data); }, [data, selectOption]);
    return (_jsx("div", { style: styles, onClick: handleClick, onMouseOver: innerProps.onMouseOver, onMouseMove: innerProps.onMouseMove, children: props.label }));
};
var SimplifiedOption = memo(SimplifiedOptionInner, function (prevProps, nextProps) { var _a, _b; return prevProps.isFocused === nextProps.isFocused && ((_a = prevProps.data) === null || _a === void 0 ? void 0 : _a.label) === ((_b = nextProps.data) === null || _b === void 0 ? void 0 : _b.label); });
export default SimplifiedOption;
